module.exports = __webpack_public_path__ + "img/p-30.8dba2b01.png";